import { useState } from "react";
import { ConfirmDialog } from "@/components/ui/ConfirmDialog";
import { useTranslation } from "@/packages/utils";

interface AuditRejectModalProps {
  open: boolean;
  onClose: () => void;
  onConfirm: (reason: string) => void;
  isPending: boolean;
}

export function AuditRejectModal({
  open,
  onClose,
  onConfirm,
  isPending,
}: AuditRejectModalProps) {
  const { t } = useTranslation(["audits"]);
  const [reason, setReason] = useState("");

  function handleClose() {
    setReason("");
    onClose();
  }

  return (
    <ConfirmDialog open={open} onClose={handleClose}>
      <ConfirmDialog.Title>
        {t("audits:actions.rejectConfirm.title")}
      </ConfirmDialog.Title>
      <ConfirmDialog.Body>
        <div className="space-y-3">
          <p className="text-sm text-secondary">
            {t("audits:actions.rejectConfirm.body")}
          </p>
          <textarea
            className="w-full rounded-md border border-border bg-background px-3 py-2 text-sm text-primary placeholder:text-secondary focus:outline-none focus:ring-2 focus:ring-ring resize-none"
            rows={4}
            placeholder={t("audits:actions.rejectConfirm.placeholder")}
            value={reason}
            onChange={(e) => setReason(e.target.value)}
            minLength={10}
            required
          />
          {reason.length > 0 && reason.trim().length < 10 && (
            <p className="text-xs text-destructive">
              {t("audits:actions.rejectConfirm.minLength")}
            </p>
          )}
        </div>
      </ConfirmDialog.Body>
      <ConfirmDialog.Actions
        onConfirm={() => onConfirm(reason)}
        confirmLabel={t("audits:actions.rejectConfirm.confirm")}
        variant="danger"
        loading={isPending}
        confirmDisabled={reason.trim().length < 10}
      />
    </ConfirmDialog>
  );
}
